import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ReviewTargetModel } from '@models/index';
import { NgxPermissionsService } from 'ngx-permissions'

import { GMBFailures, FacebookFailures } from '@enums/GMBFailures.enum';
import { CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';

export interface ChangeUrlEvent {
  reviewTarget: ReviewTargetModel;
  url: string;
}

@Component({
  selector: 'review-targets-list',
  templateUrl: './review-targets-list.component.html',
  styleUrls: ['./review-targets-list.component.sass']
})
export class ReviewTargetsListComponent {

  @ViewChild('dropList') cdkDropList: CdkDropList;

  @Input() reviewTargets: ReviewTargetModel[];
  @Input() connectedTo: CdkDropList[] = [];
  @Input() id: string = '';

  @Output() drop = new EventEmitter<CdkDragDrop<ReviewTargetModel>>();
  @Output() onSelected = new EventEmitter<ReviewTargetModel>();
  @Output() toTop = new EventEmitter<ReviewTargetModel>();
  @Output() toBottom = new EventEmitter<ReviewTargetModel>();
  @Output() delete = new EventEmitter<ReviewTargetModel>();
  @Output() changeUrl = new EventEmitter<ChangeUrlEvent>();
  @Output() changeCampaignUrl = new EventEmitter<ChangeUrlEvent>();
  @Output() changeIntegration = new EventEmitter<ReviewTargetModel>();

  @Output() loginToGoogle = new EventEmitter<ReviewTargetModel>();
  @Output() reauthToGoogle = new EventEmitter<void>();
  @Output() loginToFacebook = new EventEmitter<ReviewTargetModel>();

  permissions = this.permissionsService.getPermissions();

  constructor(
    private permissionsService: NgxPermissionsService
  ) {}

  loginWithFacebookOrChangeIntegration(reviewTarget: ReviewTargetModel) {
    if (reviewTarget.error?.name == FacebookFailures.AuthFailure
      || reviewTarget.error?.name == FacebookFailures.PermissionFailure
      || reviewTarget.error?.name == FacebookFailures.SentAuthFailure
    ) {
      console.log("Login...")
      this.loginToFacebook.emit(reviewTarget)
    } else {
      console.log("changeIntegration...")
      this.changeIntegration.emit(reviewTarget)
    }
  }

  editGmbIntegration(reviewTarget: ReviewTargetModel) {
    if (reviewTarget.error?.name == GMBFailures.AuthFailure
      || reviewTarget.error?.name == GMBFailures.SentAuthFailure
    ) {
      this.reauthToGoogle.emit()
    } else {
      this.changeIntegration.emit(reviewTarget)
    }
  }
}
